import type { App } from "vue";
import * as Sentry from "@sentry/vue";
import router from "../router";
import { EnvironmentService } from "@/utils/environment";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

export const initSentry = (app: App): void => {
    const { env, community } = EnvironmentService.parseEnvironment();

    // Skip Sentry in localhost development
    if (env === "localhost") {
        console.log("Sentry initialization skipped in localhost environment");
        return;
    }

    Sentry.init({
        app,
        dsn: sentryDsn,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        /*
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/api\..*corridorsafety\.com/,
        ],
        */

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        environment: env,
    });

    if (community) {
        Sentry.setTag("organization", community);
    }
};

const SentryPlugin = {
    install(app: App): void {
        initSentry(app);
    },
};

export default SentryPlugin;
